<template>
  <div class="card__item">
    <div class="card__icon animated-bg animated-bg-text"></div>
    <p class="card__title animated-bg animated-bg-text"></p>
    <p class="card__text animated-bg animated-bg-text"></p>
    <BaseButton
      color="outline-blue"
      class="sidebar-menu__button"
      :isLoading="true"
      size="small"
      >Смотреть</BaseButton
    >
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.card {
  &__item {
    display: flex;
    flex-direction: column;
    background: #f4fbff;
    border: 1px dashed #46adf4;
    box-sizing: border-box;
    border-radius: 8px;
    width: 100%;
    height: 23.3rem;
    padding: 2rem 1.6rem;
    justify-content: space-between;
    transition: all 0.3s ease-in-out;
    cursor: pointer;
    position: relative;

    &:hover {
      background: #0082be;
      border: 1px dashed #46adf4;
      border-radius: 0.8rem;
      & > .card {
        &__icon {
          filter: brightness(0) invert(1);
        }
        &__title {
          color: #ffffff;
        }
        &__text {
          color: #cce9ff;
        }
      }
      & > .button {
        background: #ffbe55;
        border: 1px solid #ffbe55;
        color: white;
      }
    }
  }
  &__list {
    margin-bottom: 10rem;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(256px, 1fr));
    grid-gap: 15px;
  }
  &__item {
    font-weight: 600;
    font-size: 1.4rem;
    text-align: center;
    letter-spacing: -0.02em;
    color: #005177;
  }
  &__text {
    font-size: 1.2rem;
    text-align: center;
    color: #9c9898;
  }
  &__icon {
    width: 3.8rem;
    height: 3.8rem;
    margin: 0 auto;
  }
  &__label {
    position: absolute;
    top: 3px;
    right: 3px;
    background: #ffbe55;
    border-radius: 0px 6px;
    padding: 4px 14px;
    color: #ffffff;
  }
}
</style>
